import React, { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { signUp } from "../../redux/actions/authAction";
import VerifyEmail from "../VerifyEmail";
import { Redirect, Link } from "react-router-dom";

export default function Signup(props) {
  const [isPassword, setIsPassword] = useState(true);
  const [btnText, setBtnText] = useState("Show");
  const { verifyEmailRes, isAuthenticated } = useSelector((state) => state.authData);
  const dispatch = useDispatch();
  let form = useRef();
  const togglePasswordVisibility = () => {
    setIsPassword(!isPassword);
    const tempBtnText = isPassword ? "Hide" : "Show";
    setBtnText(tempBtnText);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, password, org_name, website } = form.current;
    let formdata = {
      name: name.value,
      email: email.value,
      password: password.value,
      confirm_password: password.value,
      org_name: org_name.value,
      website: website.value,
    };
    dispatch(signUp(formdata));
  };
  /* if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    // dev code
    console.log("dev mode");
  } else {
    // production code
  } */

  useEffect(() => {
    if (isAuthenticated) {
      props.history.push("/customers");
    }
  }, [isAuthenticated]);

  return (
    <>
      {verifyEmailRes && verifyEmailRes.hasOwnProperty("id") &&  verifyEmailRes.id !== null ? (
        <Redirect to="/verify-email" />
      ) : null}

      <div className="container-fluid userservice_section">
        <div className="row align-items-center">
          <div className="col-sm-12 login_part">
            <div className="clearfix registeraArea">
              <h1 className="form_title">SIGN UP</h1>
              <form
                action=""
                className="form"
                ref={form}
                onSubmit={handleSubmit}
              >
                <div className="form-group">
                  <label className="user_form_label">Name <sup className="mandatory">*</sup></label>
                  <input type="text" className="form-control" name="name" required />
                </div>
                <div className="form-group">
                  <label className="user_form_label">Email address <sup className="mandatory">*</sup></label>
                  <input
                    type="email"
                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                    className="form-control"
                    name="email"
                    required
                  />
                </div>
                <div className="form-group password-group">
                  <label className="user_form_label">Password <sup className="mandatory">*</sup></label>
                  <div className="input-group">
                    <input
                      type={isPassword ? "password" : "text"}
                      className="form-control"
                      required
                      minLength="6"
                      name="password"
                      id="userpassword"
                    />
                    <div className="input-group-append">
                      <span
                        className="input-group-text password-group-text"
                        onClick={togglePasswordVisibility}
                      >
                        {btnText}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <label className="user_form_label">Company <sup className="mandatory">*</sup></label>
                  <input type="text" className="form-control" name="org_name" required/>
                </div>
                <div className="form-group">
                  <label className="user_form_label">Website <sup className="mandatory">*</sup></label>
                  <input type="text" className="form-control" name="website" required/>
                </div>
                <div className="form-group">
                  <button type="submit" className="btn btn-dark submit-btn">
                    Sign up
                  </button>
                </div>
                <div className="form-group">
                  <p className="termsAndService">
                    By clicking Sign Up, you agree to our{" "}
                    <a
                      target="_blank"
                      href="https://www.lambdatest.com/privacy"
                    >
                      Privacy Policy
                    </a>{" "}
                    &{" "}
                    <a
                      target="_blank"
                      href="https://www.lambdatest.com/terms-of-service"
                    >
                      Terms of Service
                    </a>
                  </p>
                  <p className="termsAndService mt-2">
                    Already have an account? <Link to="/login">Sign in</Link>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
